import { NgClass, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatError } from '@angular/material/form-field';
import { MatSlider, MatSliderThumb } from '@angular/material/slider';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
  selector: 'app-fecal-scoring-detail-pen-score-form',
  templateUrl: './fecal-scoring-detail-pen-score-form.component.html',
  styleUrls: ['./fecal-scoring-detail-pen-score-form.component.scss'],
  imports: [ReactiveFormsModule, MatSlider, MatSliderThumb, NgClass, NgIf, MatError, TranslatePipe],
})
export class FecalScoringDetailPenScoreFormComponent implements OnInit {
  @Input() isMobile: boolean;
  @Input() penScoreFormGroup: FormGroup;

  totalScore = 0;
  totalScoreError = false;

  ngOnInit(): void {
    this.penScoreFormGroup.controls.penScoreNormal.valueChanges.subscribe(() =>
      this.getPenScoreTotal(),
    );
    this.penScoreFormGroup.controls.penScoreSoft.valueChanges.subscribe(() =>
      this.getPenScoreTotal(),
    );
    this.penScoreFormGroup.controls.penScoreMild.valueChanges.subscribe(() =>
      this.getPenScoreTotal(),
    );
    this.penScoreFormGroup.controls.penScoreModerate.valueChanges.subscribe(() =>
      this.getPenScoreTotal(),
    );
    this.penScoreFormGroup.controls.penScoreSevere.valueChanges.subscribe(() =>
      this.getPenScoreTotal(),
    );

    this.getPenScoreTotal();
  }

  getPenScoreTotal(): void {
    const penScoreNormal = this.penScoreFormGroup.controls.penScoreNormal.value ?? 0;
    const penScoreSoft = this.penScoreFormGroup.controls.penScoreSoft.value ?? 0;
    const penScoreMild = this.penScoreFormGroup.controls.penScoreMild.value ?? 0;
    const penScoreModerate = this.penScoreFormGroup.controls.penScoreModerate.value ?? 0;
    const penScoreSevere = this.penScoreFormGroup.controls.penScoreSevere.value ?? 0;

    this.totalScore =
      penScoreNormal + penScoreSoft + penScoreMild + penScoreModerate + penScoreSevere;

    this.penScoreFormGroup.controls.penScoreTotal.setValue(this.totalScore);
  }
}
